import React, { createContext, useState, useContext, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import paths from "../constants/paths";
import { useNavigate } from "react-router-dom";
import { ReactComponent as WarningIcon } from "../assets/Icons/warning.svg";

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    message: null,
    type: null,
    isCustomError: false,
    autoHideDuration: 5000,
    icon: null,
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (alert.message && alert.autoHideDuration) {
      const timer = setTimeout(() => {
        setAlert({
          message: null,
          type: null,
          isCustomError: false,
          autoHideDuration: 5000,
          icon: null,
        });
      }, alert.autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, [alert.message, alert.autoHideDuration]);

  const sendAlert = (
    message,
    type,
    isCustomError = false,
    autoHideDuration = 5000,
    icon = null
  ) => {
    setAlert({ message, type, isCustomError, autoHideDuration, icon });
  };

  const handleClose = () => {
    setAlert({
      message: null,
      type: null,
      isCustomError: false,
      autoHideDuration: 5000,
      icon: null,
    });
  };

  const state = {
    ...alert,
    sendAlert,
  };

  return (
    <AlertContext.Provider value={state}>
      {alert.isCustomError && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={alert.isCustomError}
          message={
            <div style={{ display: "flex", gap: "8px", whiteSpace: "pre-line" }}>
              {alert.icon && <alert.icon sx={{ width: 400 }} />}
              <span>{alert.message}</span>
            </div>
          }
          ContentProps={{
            variant: "error",
            sx: {
              textAlign: "center",
              backgroundColor: `${alert.type}.main`,
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "nowrap",
              minHeight: "48px",
            },
          }}
          action={
            alert.autoHideDuration === null && (
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )
          }
        />
      )}
      {!alert.isCustomError && alert.message && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={!!alert.message}
          message={
            <div style={{ display: "flex", alignItems: "center", gap: "8px", whiteSpace: "pre-line" }}>
              {alert.icon && <span>{alert.icon}</span>}
              <span>{alert.message}</span>
            </div>
          }
          ContentProps={{
            variant: "error",
            sx: {
              textAlign: "center",
              backgroundColor: `${alert.type}.main`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "nowrap",
              minHeight: "48px",
            },
          }}
          action={
            alert.autoHideDuration === null && (
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )
          }
        />
      )}
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
